import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MasterModelService} from "../../share/services/master-model/master-model.service";
import {MasterMakeService} from "../../share/services/master-make/master-make.service";

@Component({
    selector: 'app-tyre-model',
    templateUrl: './tyre-model.component.html',
    styleUrls: ['./tyre-model.component.scss'],
    standalone: false
})
export class TyreModelComponent implements OnInit {
  addTyreModelForm: FormGroup;
  makeList: any[] = [];
  responseMsg:string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService
  ){
    this.addTyreModelForm = this.formBuilder.group({
      name: ['', [ Validators.required]],
      tyreMake: ['', [ Validators.required]],
    });
  }

  ngOnInit(): void {
    this.getTyreMake();
  }
  saveVehicleModel(){
    this.masterModelService.saveTyreModelDetails(this.addTyreModelForm.value).subscribe((res:any) => {
      this.responseMsg = res.message
    })
  }

  getTyreMake(){
    this.masterMakeService.getTyreMakeDetails().subscribe((res:any) => {
      this.makeList = res.tyreMakes;
    })
  }
}
